import { useEffect, useState } from "react";
import {
  deleteRealEstate,
  getAlllRealEstate,
  getAllRealEstateById,
} from "../../../services/Real_estate";
import { useOutletContext, useNavigate } from "react-router-dom";
import StyleForAllPartsMy from "../StyleForAllParts/StyleForAllPartsMy";
import StyleForAllPartsNotMy from "../StyleForAllParts/StyleForAllPartsNotMy";
import Pagination from "../../../components/Pagination/Pagination";

const SALE_RENT = "Rent";

export default function Sale({ setSearchedData, setAllDeleted, my, setEstateOn }) {
  const navigate = useNavigate();
  const [totalCount, setTotalCount] = useState(0);
  const [matchedCount, setMatchedCount] = useState(0);
  const [data, setData] = useState([]);
  const [offset, setOffset] = useState(0);
  const { brokerinfo } = useOutletContext();
  const id = brokerinfo?.broker_id || brokerinfo?.manager_id || null;

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  }, [offset]);

  useEffect(() => {
    setOffset(0);
  }, [my]);

  useEffect(() => {
    if (!id) return;

    let cancelled = false;

    const request = my
      ? getAllRealEstateById(id, { offset, saleRent: SALE_RENT })
      : getAlllRealEstate({ id, offset, saleRent: SALE_RENT });

    request
      .then((res) => {
        if (cancelled) return;
        setData(res.items);
        setTotalCount(res.total_count);
        setMatchedCount(res.matched_count ?? 0);
      })
      .catch(console.error);

    return () => {
      cancelled = true;
    };
  }, [my, id, offset]);

  const getEstateId = (item) =>
    item?.apartment_id ?? item?.house_id ?? item?.land_id ?? item?.commercial_id;

  const handleDelete = async (el, estateId) => {
    try {
      const isSame = (item) =>
        item.estate_type === el.estate_type &&
        Number(getEstateId(item)) === Number(estateId);

      setData((prev) => prev.filter((item) => !isSame(item)));
      setSearchedData((prev) => prev.filter((item) => !isSame(item)));
      setAllDeleted((prev) => [...prev, el]);
      setTotalCount((c) => Math.max(0, c - 1));
    } catch (err) {
      console.error("Delete error:", err);
    }
  };

  return (
    <div className="allElements">
      {my ? (
        <p>ԳՈՒՅՔԵՐԻ ՔԱՆԱԿԸ: {totalCount}</p>
      ) : (
        <p>
          ԳՈՒՅՔԵՐԻ ՔԱՆԱԿԸ: {matchedCount}/{totalCount}
        </p>
      )}

      <div className="allelements">
        {data.map((el) => {
          const estateId = getEstateId(el);
          const Card = my ? StyleForAllPartsMy : StyleForAllPartsNotMy;

          return (
            <Card
              key={`${el.estate_type}-${estateId}`}
              el={el}
              estateId={estateId}
              setEstateOn={setEstateOn}
              navigate={navigate}
              id={id}
              brokerinfo={brokerinfo}
              deleteRealEstate={deleteRealEstate}
              handleDelete={handleDelete}
            />
          );
        })}
      </div>

      <Pagination
        
        totalCount={totalCount}
        offset={offset}
        setOffset={setOffset}
      />
    </div>
  );
}
